import { useMemo } from 'react';
import { brandsList } from 'shared/constants';
import { getAppPermissions, getBrandsFromPermissions } from 'shared/utility';

export function usePermissions(claims: string = '') {
  const permissions = useMemo(() => getAppPermissions(claims), [claims]);
  const brands = useMemo(() => getBrandsFromPermissions(permissions).sort(), [permissions]);
  const isAdmin = useMemo(() => brandsList.every(brand => brands.includes(brand)), [brands]);

  return { permissions, brands, isAdmin };
}
